module.exports = __webpack_public_path__ + "/img/Dfn2-Custom-Footprint-pw1GdR.svg";